<template>
<div class="fourth-question">
	<grid>
		<grid-item size="1/1">
			<h2 class="question-text">{{ question.text }}</h2>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="20/62">
			<label :class="{ active: activeOption == 0 }">
				<input hidden type="radio"
					:value="0"
					v-model="response"
				/>
				<span>
					{{ question.responses[0].text }}
				</span>
			</label>
		</grid-item>
		<grid-item size="1/62">
		</grid-item>
		<grid-item size="20/62">
			<label :class="{ active: activeOption == 1 }">
				<input hidden type="radio"
					:value="1"
					v-model="response"
				/>
				<span>
					{{ question.responses[1].text }}
				</span>
			</label>
		</grid-item>
		<grid-item size="1/60">
		</grid-item>
		<grid-item size="20/60">
			<label :class="{ active: activeOption == 2 }">
				<input hidden type="radio"
					:value="2"
					v-model="response"
				/>
				<span>
					{{ question.responses[2].text }}
				</span>
			</label>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="20/62">
			<label :class="{ active: activeOption == 3 }">
				<input hidden type="radio"
					:value="3"
					v-model="response"
				/>
				<span>
					{{ question.responses[3].text }}
				</span>
			</label>
		</grid-item>
		<grid-item size="1/62">
		</grid-item>
		<grid-item size="20/62">
			<label :class="{ active: activeOption == 4 }">
				<input hidden type="radio"
					:value="4"
					v-model="response"
				/>
				<span>
					{{ question.responses[4].text }}
				</span>
			</label>
		</grid-item>
		<grid-item size="1/60">
		</grid-item>
		<grid-item size="20/60">
			<label :class="{ active: activeOption == 5 }">
				<input hidden type="radio"
					:value="5"
					v-model="response"
				/>
				<span>
					{{ question.responses[5].text }}
				</span>
			</label>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/1">
			<label :class="{ active: activeOption == 6 }">
				<input hidden type="radio"
					:value="6"
					v-model="response"
				/>
				<span>
					{{ question.responses[6].text }}
				</span>
			</label>
		</grid-item>
	</grid>
</div>
</template>

<script>
export default {
	props: [
		'value',
		'question'
	],
	data: () => ({
		activeOption: null
	}),
	computed: {
		response: {
			get() { return this.value },
			set(value) { this.$emit('input', value) }
		}
	},
	watch: {
		response(item) {
			this.activeOption = item
		}
	}
}
</script>

<style lang="scss">
.fourth-question {
	margin-bottom: 20px;

	.question-text {
		padding: 10px 50px !important;
	}
	label {
		height: 45px;
		padding: 0px 0px;
		line-height: 45px;
		margin-top: 7px;

		span {
			font-size: 11.5px !important;
		}
	}
	.label_3 {
		padding: 0 15px;
	}
}
</style>
